export function isNullOrEmpty(text: string | null | ArrayLike<unknown> | undefined): boolean {
  return text == null || text.length === 0;
}
